import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.deviceMeta ? _c(VCombobox, {
    attrs: {
      "label": _vm.label,
      "items": _vm.items,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "multiple": "",
      "search-input": _vm.search,
      "disabled": _vm.readonly,
      "data-cy": "groups"
    },
    on: {
      "keydown": _vm.restrictCharacters,
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "change": _vm.process
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function ({
        attrs,
        item
      }) {
        return [_c(VChip, _vm._b({
          attrs: {
            "small": "",
            "close": "",
            "data-cy": `tag_${item}`
          },
          on: {
            "click:close": function ($event) {
              return _vm.remove(item);
            }
          }
        }, 'v-chip', attrs, false), [_vm._v("\n      " + _vm._s(item) + "\n    ")])];
      }
    }], null, false, 4160730696),
    model: {
      value: _vm.deviceMeta.groups,
      callback: function ($$v) {
        _vm.$set(_vm.deviceMeta, "groups", $$v);
      },
      expression: "deviceMeta.groups"
    }
  }) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };